export const DENTAL = {
  nickname: 'PRODUCTS.DENTAL.shortname',
  isHidden: true,
  icon:'dental'
};
